import data from './holidays.json';

export function getHolidays() {
  return data;
}
